// extracted by mini-css-extract-plugin
export default {"video-segmentation":"lsf-video-segmentation","video-segmentation_fullscreen":"lsf-video-segmentation_fullscreen","video-segmentation__main":"lsf-video-segmentation__main","video-segmentation__timeline":"lsf-video-segmentation__timeline","video":"lsf-video","video_fullscreen":"lsf-video_fullscreen","video__main":"lsf-video__main","video__controls":"lsf-video__controls","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630383411
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  